module.exports = __webpack_public_path__ + "img/phoneIcon.cc70e88d.svg";